"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useCurrentQuestion = require("../../hooks/questionnaire/useCurrentQuestion");
var _constants = require("../../utils/constants");
var _questionnaireUtil = require("../../utils/questionnaireUtil");
var _BaseComponents = require("../StyledComponents/BaseComponents");
var _QuestionWithBudget = require("./QuestionWithBudget");
var _QuestionWithChoices = _interopRequireDefault(require("./QuestionWithChoices"));
var _QuestionWithImages = _interopRequireDefault(require("./QuestionWithImages"));
var _QuestionWithMulti = _interopRequireDefault(require("./QuestionWithMulti"));
var _QuestionWithRange = _interopRequireDefault(require("./QuestionWithRange"));
var _QuestionWithSearch = _interopRequireDefault(require("./QuestionWithSearch"));
var _QuestionWithAddressSearch = _interopRequireDefault(require("./QuestionWithAddressSearch"));
var _QuestionWithAddressInputFields = _interopRequireDefault(require("./QuestionWithAddressInputFields"));
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _QuestionWithStopMessage = _interopRequireDefault(require("./QuestionWithStopMessage"));
var _CoverageChecker = _interopRequireDefault(require("./CoverageChecker"));
var _QuestionWithTextInput = _interopRequireDefault(require("./QuestionWithTextInput"));
var _useLocalTheme3 = _interopRequireDefault(require("../../hooks/useLocalTheme"));
var _useScrollToTop = require("../../hooks/app/useScrollToTop");
var _useAppSelector = require("../../hooks/useAppSelector");
var _useAppDispatch = require("../../hooks/useAppDispatch");
var _questionnaireActions = require("../../store/questionnaire/questionnaireActions");
var _errorSelectors = require("../../store/error/errorSelectors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const StyledGridRow = (0, _BaseComponents.BodyBackground)(_r10SourceLibrary.GridRow);
const StyledQuestionWrapper = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)`
  display: block;
`;
const QuestionnaireBodyContainer = _styledComponents.default.div`
  width: ${_ref => {
  var _modalBody$contentWid, _modalBody$contentWid2;
  let {
    modalBody,
    breakpoints
  } = _ref;
  return modalBody !== null && modalBody !== void 0 && modalBody.contentWidth ? breakpoints.sm ? (_modalBody$contentWid = modalBody.contentWidth) === null || _modalBody$contentWid === void 0 ? void 0 : _modalBody$contentWid.sm : (_modalBody$contentWid2 = modalBody.contentWidth) === null || _modalBody$contentWid2 === void 0 ? void 0 : _modalBody$contentWid2.lg : '100%';
}};
`;
const QuestionnaireBody = () => {
  var _useLocalTheme, _useLocalTheme2;
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const {
    question,
    selections
  } = (0, _useCurrentQuestion.useCurrentQuestion)();
  const {
    showModalView
  } = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectUiSettings);
  const bodyBackgroundColor = (0, _useLocalTheme3.default)('modalBody.backgroundColor');
  const override = (_useLocalTheme = (0, _useLocalTheme3.default)('modalBody.override')) !== null && _useLocalTheme !== void 0 ? _useLocalTheme : false;
  (0, _useScrollToTop.useScrollToTop)('[class^="Containerstyle__ContainerContent"]', [question]);
  const QuestionComponent = question => {
    switch (question.type) {
      case _constants.QUESTION_TYPE.CHOICES:
        return _QuestionWithChoices.default;
      case _constants.QUESTION_TYPE.RANGE:
        return (0, _questionnaireUtil.isBudgetQuestion)(question) ? _QuestionWithBudget.QuestionWithBudget : _QuestionWithRange.default;
      case _constants.QUESTION_TYPE.MULTI:
        return (0, _questionnaireUtil.isBudgetQuestion)(question) ? _QuestionWithBudget.QuestionWithBudget : _QuestionWithMulti.default;
      case _constants.QUESTION_TYPE.SEARCH:
        return _QuestionWithSearch.default;
      case _constants.QUESTION_TYPE.IMAGE:
        return _QuestionWithImages.default;
      case _constants.QUESTION_TYPE.ADDRESS_SEARCH:
        return _QuestionWithAddressSearch.default;
      case _constants.QUESTION_TYPE.ADDRESS_INPUT:
        return _QuestionWithAddressInputFields.default;
      case _constants.QUESTION_TYPE.STOP_MESSAGE:
        return _QuestionWithStopMessage.default;
      case _constants.QUESTION_TYPE.COVERAGE_CHECKER:
        return _CoverageChecker.default;
      case _constants.QUESTION_TYPE.TEXT_INPUT:
        return _QuestionWithTextInput.default;
      default:
        return null;
    }
  };
  if (!question) {
    return null;
  }
  const QuestionComponentInstance = QuestionComponent(question);
  if (!QuestionComponentInstance) {
    return null;
  }
  const Wrapper = showModalView ? _r10SourceLibrary.Spacing : _react.Fragment;
  const {
    modalBody
  } = (_useLocalTheme2 = (0, _useLocalTheme3.default)()) !== null && _useLocalTheme2 !== void 0 ? _useLocalTheme2 : {};
  const breakpoints = (0, _r10SourceLibrary.useBreakpoints)();
  const budgetQuestionBottomSpacing = (0, _useLocalTheme3.default)('budgetQuestionBottomSpacing', 6);
  const questionTopSpacing = (0, _useLocalTheme3.default)('questionTopSpacing', 2);
  const hasError = (0, _useAppSelector.useAppSelector)(_errorSelectors.selectHasError);
  (0, _react.useEffect)(() => {
    if (!hasError) dispatch((0, _questionnaireActions.setViewQuestionTags)());
  }, []);
  return /*#__PURE__*/_react.default.createElement(QuestionnaireBodyContainer, {
    modalBody: modalBody,
    breakpoints: breakpoints
  }, /*#__PURE__*/_react.default.createElement(Wrapper, {
    spacingLevel: {
      top: questionTopSpacing,
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(StyledGridRow, {
    align: 'center',
    override: override,
    color: bodyBackgroundColor
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 6,
      bottom: budgetQuestionBottomSpacing,
      left: 4,
      right: 4
    }
  }, /*#__PURE__*/_react.default.createElement(StyledQuestionWrapper, {
    align: 'stretch'
  }, /*#__PURE__*/_react.default.createElement(QuestionComponentInstance, {
    question: question,
    selections: selections
  })))))));
};
var _default = QuestionnaireBody;
exports.default = _default;